export default "__VITE_ASSET__04413fe9__"